export default __webpack_public_path__ + "static/media/landscape6.ef47819b.jpeg";